export default __webpack_public_path__ + "static/media/discount.2ff4d19a.svg";